export default "__VITE_ASSET__B6br1lMR__"